import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';

export const SortableRow = ({ row, onEdit, onRemove }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: row.id });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1
      }}
      className='sortable-row'
    >
      <div className='drag-handle' {...attributes} {...listeners}>
        ⋮
      </div>
      <div className='row-title'>{row.title}</div>
      {row.filter?.circle_index != null && <div className='row-circle-index'>Circle #{row.filter.circle_index}</div>}
      <div className='row-actions'>
        <button type='button' className='edit-row-button' onClick={() => onEdit(row)}>
          Edit
        </button>
        <button type='button' className='delete-row-button' onClick={() => onRemove(row.id)} title='Remove from grid'>
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>
    </div>
  );
};
